import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'pcm-dashboard-action-widget',
	templateUrl: './dashboard-action-widget.component.html',
	styleUrls: ['./dashboard-action-widget.component.scss']
})
export class DashboardActionWidgetComponent {

	@Input() title = '';
	@Input() path = '';

	constructor(
		private router: Router
	) { }

	widgetClick() {
		this.router.navigateByUrl(this.path);
	}
}
